import { render, staticRenderFns } from "./DbSwitchProgress.vue?vue&type=template&id=cfeac6ac"
import script from "./DbSwitchProgress.vue?vue&type=script&lang=js"
export * from "./DbSwitchProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports